"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDOMRoot = exports.createElement = exports.browser = void 0;
const react_1 = require("react");
exports.browser = typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement;
function createElement(tagName, attributes = {}) {
    const $el = document.createElement(tagName);
    const { className } = attributes, attrs = __rest(attributes, ["className"]);
    className &&
        className.split(' ').forEach((className) => $el.classList.add(className));
    Object.keys(attrs).forEach((name) => {
        $el.setAttribute(name, attributes[name]);
    });
    return $el;
}
exports.createElement = createElement;
const defaultContainer = exports.browser
    ? { current: document.body }
    : { current: null };
const useDOMRoot = ({ anchor, style, container = defaultContainer, }) => {
    const [root, setRoot] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!container.current)
            return;
        let launchpad = container.current.querySelector(`:scope > [data-${anchor}]`);
        if (!launchpad) {
            launchpad = createElement('div', {
                className: style,
                [`data-${anchor}`]: '',
            });
            container.current.appendChild(launchpad);
        }
        setRoot(launchpad);
    }, [container, anchor, style]);
    return root;
};
exports.useDOMRoot = useDOMRoot;
